import { Component, computed, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { UsersDataService } from '@recruitee/account-data';
import { User } from '@recruitee/account-types';
import { CustomFieldConfiguration } from '@recruitee/custom-fields-types';

import {
  MultiSelectCustomFieldComponent,
  MultiselectOption,
} from '../../multi-select-custom-field/multi-select-custom-field.component';

@Component({
  selector: 'rt-multi-user-custom-field-container',
  imports: [MultiSelectCustomFieldComponent],
  template: `<rt-multi-select-custom-field
    [control]="control()"
    [selectOptions]="selectOptions()"
    [isReadOnly]="isReadOnly()"
    [isInvalid]="isInvalid()"
  ></rt-multi-select-custom-field>`,
})
export class MultiUserCustomFieldContainerComponent {
  public readonly usersDataService = inject(UsersDataService);

  public control = input.required<FormControl<number[]>>();
  public configuration = input<Pick<CustomFieldConfiguration, 'admins' | 'roles'>>();
  public isReadOnly = input<boolean>(false);
  public isInvalid = input<boolean>(false);

  public selectOptions = computed<MultiselectOption[]>(() => {
    const preselectedAdmins = this.configuration()?.admins;
    const preselectedRoles = this.configuration()?.roles;

    const usersData: User[] = preselectedAdmins?.length
      ? this.usersDataService.getUsersByIds(preselectedAdmins)()
      : preselectedRoles?.length
        ? this.usersDataService.getUsersByRoles(preselectedRoles)()
        : this.usersDataService.getAllUsers()();

    return usersData.map(user => ({
      value: user.id,
      label: `${user.firstName} ${user.lastName}`,
      imageUrl: user.photoThumbUrl,
    }));
  });
}
